<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="ded"><a id="page_v">I dedicate this book to the butterflies in all of us, and to my Bobby, who made me believe I could fly.</a></p><a id="page_v">
</a></div><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?2972b6ed